<template>
  <div class="vx-row mb-6">
    <div class="vx-col sm:w-1/5 w-full">
      <span>E-mail template</span>
    </div>
    <div class="vx-col sm:w-3/5 w-full">
      <vs-select v-model="templateId">
        <vs-select-item
          :key="index"
          :value="item.id"
          :text="item.name"
          v-for="(item, index) in emailTemplates"
        />
      </vs-select>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      templateId: "",
    };
  },
  methods: {
    render() {
      return {
        templateId: this.templateId,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      emailTemplates: "emailTemplates/emailTemplates",
    }),
  },
  async mounted() {
    await this.$store.dispatch("emailTemplates/getAll", false);
    if (this.action) {
      this.templateId = this.action.templateId;
    }
  },
};
</script>

<style lang="scss">
</style>